import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SectionHeadline = ({ className, sectionNumber, label, color }) => {
  return (
    <div className={classNames(['label-option__main', className])}>
      <div style={{ color, border: `1px solid ${color}` }} className="label-option__oval-number">
        <span className="label-option__text">{sectionNumber}</span>
      </div>
      <div>
        <p style={{ color }} className="label-option__text ml-2">
          {label}
        </p>
      </div>
    </div>
  );
};

SectionHeadline.defaultProps = {
  className: '',
};

SectionHeadline.propTypes = {
  className: PropTypes.string,
  sectionNumber: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default SectionHeadline;
